import React from 'react';
import Ratings from '../common/Rating';
import Types from '../common/Types';
import UserAvatar from '../common/UserAvatar';

const tableConfig = (props) => ({
    columns: [
        { 
            title: 'User', field: 'name', filterAndSearch: true,width:"150px",
            render: rowData => <UserAvatar name={rowData.name} image={rowData.dpUrl}/>
        },
        { title: 'Email', field: 'emailId', filterAndSearch: true ,width:"200px"},
		{ title: 'Order ID', field: 'orderId', filterAndSearch: true,width:"100px" },
		{ title: 'Payment ID', field: 'paymentId', filterAndSearch: true ,width:"100px"},
        { title: 'Received on', field: 'date', filterAndSearch: false,width:"150px" },
        { title: 'Amount', field: 'amount', filterAndSearch: true ,width:"100px",
		render:rowData=><div>{( rowData.currency === "&#8377;") ? <span>&#8377;{rowData.amount}</span> : <span>&#36;{rowData.amount}</span>}</div>
	    },
       	{ title: 'Status', field: 'status', filterAndSearch: true,width:"150px" },
    ],
})

export const data = [
	{
	  "_id": "5f3bbcf8bd2288dcdccf35d2",
	  "item": "Test item",
	  "orderId": 1234,
	  "weight": "100gm",
	  "qty": 2,
	  "price": 200,
	  "buyer": "Test Buyer",
	  "seller": "Test Seller",
	  "orderedAt": "Apr 2020",
	  "status": "pending"
	},
	{
	  "_id": "5f3bbcf8958c595f4833db3e",
	  "item": "Test item",
	  "orderId": 1234,
	  "weight": "100gm",
	  "qty": 2,
	  "price": 200,
	  "buyer": "Test Buyer",
	  "seller": "Test Seller",
	  "orderedAt": "Apr 2020",
	  "status": "pending"
	},
	{
	  "_id": "5f3bbcf8ff0a6a4cf4e81ba9",
	  "item": "Test item",
	  "orderId": 1234,
	  "weight": "100gm",
	  "qty": 2,
	  "price": 200,
	  "buyer": "Test Buyer",
	  "seller": "Test Seller",
	  "orderedAt": "Apr 2020",
	  "status": "pending"
	},
	{
	  "_id": "5f3bbcf8da097fceb33eda11",
	  "item": "Test item",
	  "orderId": 1234,
	  "weight": "100gm",
	  "qty": 2,
	  "price": 200,
	  "buyer": "Test Buyer",
	  "seller": "Test Seller",
	  "orderedAt": "Apr 2020",
	  "status": "pending"
	},
	{
	  "_id": "5f3bbcf815c275e3c40187bd",
	  "item": "Test item",
	  "orderId": 1234,
	  "weight": "100gm",
	  "qty": 2,
	  "price": 200,
	  "buyer": "Test Buyer",
	  "seller": "Test Seller",
	  "orderedAt": "Apr 2020",
	  "status": "pending"
	},
	{
	  "_id": "5f3bbcf8da5fef114c2204e7",
	  "item": "Test item",
	  "orderId": 1234,
	  "weight": "100gm",
	  "qty": 2,
	  "price": 200,
	  "buyer": "Test Buyer",
	  "seller": "Test Seller",
	  "orderedAt": "Apr 2020",
	  "status": "pending"
	}
];

export default tableConfig;